export default "__VITE_ASSET__BvGpNubx__"